// @module Tavanoteam.Calculator.Calculator
define('Calculator.SquareFoot.Square.View'
    , [
        'calculator_square_foot_square.tpl'

        , 'Backbone'
        , 'jQuery'
    ]
    , function (
        calculator_square_foot_square_tpl

        , Backbone
        , jQuery
    ) {
        'use strict';

        return Backbone.View.extend({

            template: calculator_square_foot_square_tpl

            , initialize: function (options) {

            }

            , events: {
                'click [data-action="calculate-square-foot-square"]': 'calculateArea',
                'click [data-action="reset"]': 'resetAllFields'
            }

            , calculateArea: function calculateArea() {
                //input fields
                var length = $('#square-foot-square-length').val();
                //output fields
                var area = $('#square-foot-square-area');

                var result = parseFloat(length) * parseFloat(length);

                area.val(result.toFixed(2));
            }

            , resetAllFields: function resetAllFields() {
                $('.calculator-square-foot-square-input-fields').find('input:text').val('');
                $('.calculator-square-foot-square-output-fields').find('input:text').val('');
            }

            , getContext: function getContext()
            {
                return {
                    isActive : true
                }
            }
        });
    });
